import type { CountryStates } from './country-states.model';

const countryStatesData: Record<string, readonly CountryStates[]> = {
  BD: [
    {
      id: 2,
      stateCode: 'B',
      name: 'Chittagong',
    },
    {
      id: 3,
      stateCode: 'C',
      name: 'Dhaka',
    },
  ],
  IN: [
    {
      id: 9,
      stateCode: 'DL',
      name: 'Delhi',
    },
    {
      id: 21,
      stateCode: 'MH',
      name: 'Maharastra',
    },
  ],
  CA: [
    {
      id: 1,
      stateCode: 'AB',
      name: 'Alberta',
    },
    {
      id: 9,
      stateCode: 'ON',
      name: 'Ontario',
    },
  ],
  US: [
    {
      id: 15,
      stateCode: 'IL',
      name: 'Illinois',
    },
    {
      id: 16,
      stateCode: 'IN',
      name: 'Indiana',
    },
    {
      id: 17,
      stateCode: 'KS',
      name: 'Kansas',
    },
    {
      id: 18,
      stateCode: 'KY',
      name: 'Kentucky',
    },
    {
      id: 19,
      stateCode: 'LA',
      name: 'Louisiana',
    },
    {
      id: 20,
      stateCode: 'MA',
      name: 'Massachusetts',
    },
  ],
};

export function generateCountryStateObjects(
  countryCode: string,
): readonly CountryStates[] {
  const states = countryStatesData[countryCode];
  if (!states) {
    throw new Error(`Unhandled country code: '${countryCode}'`);
  }
  return states;
}
